import { z } from "zod";

export const DTOStorybookUploadUrlRequest = z.object({
  name: z.string(),
});

export const DTOStorybookUploadUrlResponse = z.object({
  signedUrl: z.string(),
  storybookUploadId: z.string(),
});

export const DTOStorybookAccessTokenResponse = z.object({
  accessToken: z.string(),
});

export const DTOStorybookAccessTokenPayload = z.object({
  designSystemId: z.string(),
  storybookUploadId: z.string(),
});

export const DTOStorybookUploadStatus = z.object({
  status: z.enum(["Failed", "InProgress", "Completed", "Unknown"]),
  timestamp: z.number().optional(),
  reason: z.string().optional(),
});

export const DTOStorybookEntryOrigin = z.object({
  id: z.string(),
  type: z.enum(["story", "docs"]),
  name: z.string(),
  title: z.string(),
});

export const DTOStorybookEntry = z.object({
  id: z.string(),
  storyId: z.string(),
  designSystemId: z.string(),
  sourceId: z.string(),
  aliases: z.array(z.string()).optional(),
  url: z.string(),
  isDeleted: z.boolean().optional(),
  origin: DTOStorybookEntryOrigin,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export const DTOStorybookEntryReplaceAction = z.object({
  newStoryId: z.string(),
});

export const DTOStorybookEntryQuery = z.object({
  /**
   * Unique ID across versions (non-persistent ID)
   */
  brandId: z.string().optional(),
});

export const DTOStorybookEntryListResponse = z.object({ entries: z.array(DTOStorybookEntry) });
export const DTOStorybookEntryResponse = z.object({ entry: DTOStorybookEntry });

export type DTOStorybookEntryQuery = z.infer<typeof DTOStorybookEntryQuery>;
export type DTOStorybookEntry = z.infer<typeof DTOStorybookEntry>;
export type DTOStorybookEntryOrigin = z.infer<typeof DTOStorybookEntryOrigin>;
export type DTOStorybookEntryReplaceAction = z.infer<typeof DTOStorybookEntryReplaceAction>;
export type DTOStorybookEntryListResponse = z.infer<typeof DTOStorybookEntryListResponse>;
export type DTOStorybookEntryResponse = z.infer<typeof DTOStorybookEntryResponse>;
export type DTOStorybookUploadUrlRequest = z.infer<typeof DTOStorybookUploadUrlRequest>;
export type DTOStorybookUploadUrlResponse = z.infer<typeof DTOStorybookUploadUrlResponse>;
export type DTOStorybookAccessTokenResponse = z.infer<typeof DTOStorybookAccessTokenResponse>;
export type DTOStorybookAccessTokenPayload = z.infer<typeof DTOStorybookAccessTokenPayload>;
export type DTOStorybookUploadStatus = z.infer<typeof DTOStorybookUploadStatus>;
